<template>
  <span
    class="localised-field-indicator"
    :style="tooltipVariables"
    tabindex="0"
    :aria-label="tooltip"
    ref="indicator"
    @mouseenter="updateTooltipPosition"
    @focus="updateTooltipPosition"
  >
    <fa
      class="localised-field-indicator__icon"
      :icon="['fas', 'globe-americas']"
    />
    <span class="localised-field-indicator__tooltip" role="tooltip">
      {{ tooltip }}
    </span>
  </span>
</template>

<script>
export default {
  name: "LocalisedFieldIndicator",

  props: {
    tooltip: {
      type: String,
      default:
        "This field supports localisation. Change language using the selector dropdown at the top right of the screen."
    }
  },

  data() {
    return {
      tooltipVariables: null
    };
  },

  mounted() {
    this.updateTooltipPosition();
    window.addEventListener("resize", this.updateTooltipPosition);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateTooltipPosition);
  },

  methods: {
    // if in edit canvas menu
    updateTooltipPosition() {
      const indicator = this.$refs.indicator;
      if (!indicator) return;

      const menu = indicator.closest(".tag-info, .tag-menu, .edit-box");
      if (!menu) {
        this.tooltipVariables = null;
        return;
      }

      const indicatorRect = indicator.getBoundingClientRect();
      const menuRect = menu.getBoundingClientRect();
      const inset = 20;

      this.tooltipVariables = {
        "--localised-tooltip-left": `${menuRect.left +
          inset -
          indicatorRect.left}px`,
        "--localised-tooltip-width": `${Math.max(
          menuRect.width - inset * 2,
          200
        )}px`,
        "--localised-tooltip-transform": "translate(0, -3px)",
        "--localised-tooltip-hover-transform": "translate(0, 0)",
        "--localised-tooltip-bottom": "auto",
        "--localised-tooltip-top": "18px"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.localised-field-indicator {
  color: #8a9aaa;
  cursor: help;
  display: inline-flex;
  line-height: 1;
  margin-left: 2px;
  opacity: 0.65;
  position: relative;
  text-transform: none;
  vertical-align: baseline;
  transform: translateY(1px);

  &:focus {
    outline: none;
  }

  &:focus-visible {
    color: #607d9f;
    outline: 2px solid rgba(96, 125, 159, 0.45);
    outline-offset: 2px;
  }

  &:hover,
  &:focus {
    color: #607d9f;
    opacity: 1;

    .localised-field-indicator__tooltip {
      opacity: 1;
      pointer-events: auto;
      transform: var(--localised-tooltip-hover-transform, translate(-50%, 0));
    }
  }

  &__icon {
    font-size: 11px;
  }

  &__tooltip {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 0px 2.2px rgba(0, 0, 0, 0.028),
      0 0px 5.3px rgba(0, 0, 0, 0.04), 0 0px 10px rgba(0, 0, 0, 0.05),
      0 0px 17.9px rgba(0, 0, 0, 0.06), 0 0px 33.4px rgba(0, 0, 0, 0.072),
      0 0px 80px rgba(0, 0, 0, 0.1);
    color: #222;
    font-size: 13px;
    font-weight: 400;
    left: var(--localised-tooltip-left, 50%);
    line-height: 1.35;
    opacity: 0;
    padding: 8px 10px;
    pointer-events: none;
    position: absolute;
    text-align: left;
    text-transform: none;
    bottom: var(--localised-tooltip-bottom, 18px);
    top: var(--localised-tooltip-top, auto);
    transform: var(--localised-tooltip-transform, translate(-50%, -3px));
    transition: opacity 0.2s, transform 0.2s;
    width: var(--localised-tooltip-width, 230px);
    z-index: 11000;
  }
}
</style>
